import React from 'react';
import {withStyles} from "@material-ui/core";
import AgIcon from "./commons/AgIcon";
import Typography from "@material-ui/core/Typography";
import PropTypes from 'prop-types';
import clsx from "clsx";

const styles = theme => ({
    root: {
        background: theme.palette.common.white,
        height: ({expanded}) => expanded ? 190 : 141,
        display: 'flex',
        flexFlow: 'column nowrap',
        justifyContent: 'center'
    },
    content: {
        display: 'flex',
        alignItems: 'center',
        padding: [[theme.spacing(2), theme.spacing(3)]],
        color: theme.palette.text.primary
    },
    icon: {
        marginRight: theme.spacing(4),
    }
});

const Offline = ({className, classes, realTime, ...props}) => {
    return (
        <div className={clsx(classes.root, className)}>
            {realTime && (
                <div className={classes.content}>
                    <AgIcon className={classes.icon} icon='offline' size={80}/>
                    <Typography variant='h4'>Sensor offline</Typography>
                </div>
            )}
            {!realTime && (
                <div className={classes.content}/>
            )}
        </div>
    );
};

Offline.propTypes = {
    expanded: PropTypes.bool.isRequired
};

Offline.defaultProps = {
    expanded: false
};

export default withStyles(styles)(Offline);
